import InstrumentPlayer from './InstrumentPlayer';

export default InstrumentPlayer;



// WEBPACK FOOTER //
// ./src/lib/utils/InstrumentPlayer/index.js